<template>
  <div>
    <v-lp-tool-bar/>
    <v-img
      :src="mainImage"
      gradient="to top right, rgba(0,0,0,.33), rgba(0,0,0,.7)"
      :height="500"
    >
      <v-container
        fill-height
        class="main--text"
      >
        <v-row
          justify=end
          align=center
        >
          <v-col
            cols=12
            md=6
          >
            <h3
              class="white--text"
            >自宅で始める<br>プログラミング学習</h3>
            <br>
            <h1
              :class="headingStyle"
            >
              無料体験<br>受付中
            </h1>
          </v-col>
        </v-row>
      </v-container>
    </v-img>
    <v-sheet>
      <v-container
        class=main--text
        fluid
      >
        <v-row
          justify=center>
          <v-col
            cols=auto>
            <h1>子どものプログラミング教室って、どう選べば良いの…？</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols=12
            sm=6>
            <v-img
              :src="introImage"
              :aspect_ratio="9/16"
              height=400>
            </v-img>
          </v-col>
          <v-col
            cols=12
            sm=6
          >
              <v-row>
                <ul class="trouble--list">
                  <li>近くに良さそうな教室がなくて…</li>
                  <li>本当に将来役に立つの…？</li>
                  <li>ちゃんと身につくか不安…</li>
                  <li>送り迎えが大変じゃ…</li>
                </ul>
              </v-row>
              <v-row
                justify=center>
                <v-col
                  cols=auto
                  >
                  <h1 class="emphasis--phrase">Prosenseに</h1>
                </v-col>
              </v-row>
              <v-row
                justify=center
              >
                <v-col
                  cols=auto
                  class="no--vertical--paddings">
                  <h1 class="emphasis--phrase">お任せください！</h1>
                </v-col>
              </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
    <VToContactIcon/>
    <v-section-bar
      id='what-to-learn'
      message="身につくチカラ"/>
    <v-container
      fluid
      class=main--text
    >
      <v-row
        justify=center
      >
        <v-col
          cols=12
          md=8>
          <v-what-to-learn-card/>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      class="main--text">
      <VToContactIcon/>
    </v-container>
    <v-section-bar
      id="strong-points"
      message="Prosenseの強み"/>
    <v-container
      class="main--text"
      fluid>
      <v-row>
        <v-col
          cols=12
          md=6>
          <v-container
            fluid>
            <v-row
              justify=center>
              <v-col
                cols=auto>
                <h2 class="emphasis--phrase">ブラウザで簡単にスタート</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols=12>
                <v-img
                  :src="editorImage"></v-img>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col
          cols=12
          md=6>
          <v-container
            fluid>
            <v-row
              justify=center>
              <v-col
                cols=auto>
                <h2 class="emphasis--phrase">一対一の個別指導</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols=12>
                <v-img
                  :src="videoImage"></v-img>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
    <v-strong-point-cards/>

    <VToContactIcon/>

    <VTeachersProfile/>

    <VToContactIcon/>

    <VTrialLesson/>

    <VToContactIcon/>

    <v-section-bar
      id="user-voices"
      message="保護者の方からの声"
    />
    <v-sheet
      class="main--text"
    >
      <v-container
        fluid>
        <v-row
          justify=center>
          <v-col
            cols=12
            sm=10
            md=8>
            <v-users-voices/>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
    <VToContactIcon/>
    
    <VFaq/>

    <VToContactIcon/>

    <VLineBenefit/>

    <VToContactIcon/>
    
    <VFreeTrial/>

    <VToContactIcon/>
    <v-lp-footer/>
  </div>
</template>

<script>
import MainImage from '@/assets/img/main_image.jpg'
import IntroImage from '@/assets/img/introduction_trouble.jpg'
import TrialImage from '@/assets/img/trial.jpg'
import EditorImage from '@/assets/img/editor.jpg'
import VideoImage from '@/assets/img/video.jpg'
import SupportHeartImage from '@/assets/img/support_heart.jpg'
import VFreeTrial from '@/components/organisms/lp/VFreeTrial.vue'
import VLpToolBar from '@/components/organisms/lp/VLpToolBar.vue'
import VSectionBar from '@/components/molecules/VSectionBar.vue'
import VPortalFooter from '@/components/organisms/portal/VPortalFooter.vue'
import VLpFooter from '@/components/organisms/lp/VLpFooter.vue'
import VToContactIcon from '@/components/organisms/portal/VToContactIcon.vue'
import VWhatToLearnCard from '@/components/organisms/lp/VWhatToLearnCard.vue'
import VUsersVoices from '@/components/organisms/lp/VUsersVoices.vue'
import VFaq from '@/components/organisms/lp/VFaq.vue'
import VStrongPointCards from '@/components/organisms/lp/VStrongPointCards.vue'
import VTeachersProfile from '@/components/organisms/lp/VTeachersProfile.vue'
import VLineBenefit from '@/components/organisms/lp/VLineBenefit.vue'
import VTrialLesson from '@/components/organisms/lp/VTrialLesson.vue'

import { app } from '@/core/firebase'

export default {
  components: {
    VLpToolBar,
    VPortalFooter,
    VLpFooter,
    VSectionBar,
    VToContactIcon,
    VWhatToLearnCard,
    VUsersVoices,
    VFaq,
    VStrongPointCards,
    VLineBenefit,
    VFreeTrial,
    VTrialLesson,
    VTeachersProfile
  },
  data: () => {
    return {
      storage: null,
      mainImage: MainImage,
      introImage: IntroImage,
      trialImage: TrialImage,
      editorImage: EditorImage,
      videoImage: VideoImage,
      supportHeartImage: SupportHeartImage,
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    headingStyle () {
      return (this.isMobile) ? 'heading-text-mobile' : 'heading-text'
    }
  }
}
</script>

<style scoped>
.heading-text {
  text-shadow: 0 2px 4px rgba(41,48,59,.55);
  font-weight: 600;
  color: white;
  font-size:5.0rem;
  letter-spacing:5px;
}

.heading-text-mobile {
  text-shadow: 0 2px 4px rgba(41,48,59,.55);
  font-weight: 600;
  color: white;
  font-size:3.5rem;
  letter-spacing:3px;
}

.no--vertical--paddings {
  padding: 0px 12px;
}

.trouble--list li {
  margin: 0px 0px 10px 10px;
  font-weight: bold;
  font-size: 1.4rem;
  color: brown
}

.emphasis--phrase {
  background: linear-gradient(transparent 60%, #ffff66 60%)
}


</style>

